import {
  SET_CLASS_COUNT,
  SET_CLASSES_DATA,
  SET_CLASS_DATA,
} from "../types/types";

export const setClassesData = (value) => {
  return {
    type: SET_CLASSES_DATA,
    payload: { data: value },
  };
};

export const setClassCount = (value) => {
  return {
    type: SET_CLASS_COUNT,
    payload: { data: value },
  };
};

export const setClassData = (value) => {
  return {
    type: SET_CLASS_DATA,
    payload: { data: value },
  };
};
export const setAppointments = (value) => {
  return {
    type: "SET_APPOINTMENTS",
    payload: { data: value },
  };
};

export const setClassMembers = (value) => {
  return {
    type: "SET_CLASS_MEMBERS",
    payload: { data: value },
  };
};
export const setClassesForWeek = (value) => {
  return {
    type: "SET_CLASSES_FOR_WEEK",
    payload: { data: value },
  };
};

export const toggleClassInfoModal = () => {
  return {
    type: "TOGGLE_INFO_CLASS_MODAL_OPEN",
  };
};

export const toggleClassEditModal = (value) => {
  return {
    type: "TOGGLE_EDIT_CLASS_MODAL",
    payload: { data: value },
  };
};
export const toggleClassCancelModal = (value) => {
  return {
    type: "TOGGLE_CLASS_CANCEL_MODAL",
    payload: { data: value },
  };
};
export const toggleCancelBookingModal = () => {
  return {
    type: "TOGGLE_BOOKING_CANCEL_MODAL",
  };
};
export const toggleSettlePaymentModal = () => {
  return {
    type: "TOGGLE_SETTLE_PAYMENT_MODAL",
  };
};
export const toggleDeductFromPackageModal = (value) => {
  return {
    type: "TOGGLE_DEDUCT_PACKAGE_MODAL",
    payload: { data: value },
  };
};
export const DeductFromPackageInfo = (value) => {
  return {
    type: "DEDUCT_PACKAGE_INFO",
    payload: { data: value },
  };
};
export const toggleAddToBookingListModal = () => {
  return {
    type: "TOGGLE_ADD_TO_BOOKING_LIST_MODAL",
  };
};
export const setSelectedClassId = (value) => {
  return {
    payload: { data: value },
    type: "SET_SELECTED_CLASS_ID",
  };
};
export const setMemberSupportedPackagesForClass = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_SUPPORTED_PACKAGES_FOR_CLASS",
  };
};

export const toggleAddingSaleFromClassInfo = (payload) => {
  return {
    payload: { data: payload },
    type: "TOGGLE_ADDING_SALE_FROM_CLASS_INFO",
  };
};
export const toggleBookAppointmentModal = () => {
  return {
    type: "TOGGLE_BOOK_APPOINTMENT_MODAL",
  };
};
export const setSingleAppointment = (payload) => {
  return {
    payload: { data: payload },
    type: "SET_SINGLE_APPOINTMENT",
  };
};
export const setAppointmentsBookings = (payload) => {
  return {
    payload: { data: payload },
    type: "SET_APPOINTMENTS_BOOKINGS",
  };
};
export const resetAppointmentsBookings = (payload) => {
  return {
    type: "RESET_APPOINTMENTS_BOOKINGS",
  };
};
export const setAllWeeklySchedule = (payload) => {
  return {
    payload: { data: payload },
    type: "SET_ALL_WEEKLY_SCHEDULE",
  };
};
export const setAppointmentsForWeek = (payload) => {
  return {
    payload: { data: payload },
    type: "SET_APPOINTMENTS_FOR_WEEK",
  };
};
export const setForceAddModalOpen = (payload) => {
  return {
    type: "SET_FORCE_ADD_MODAL_OPEN",
    payload: { data: payload },
  };
};
export const setAllClassesModalOpen = (payload) => {
  return {
    type: "SET_ALL_CLASSES_MODAL_OPEN",
    payload: { data: payload },
  };
};
